import { render, staticRenderFns } from "./VoucherInput.vue?vue&type=template&id=70560bb8&scoped=true"
import script from "./VoucherInput.vue?vue&type=script&lang=js"
export * from "./VoucherInput.vue?vue&type=script&lang=js"
import style0 from "./VoucherInput.vue?vue&type=style&index=0&id=70560bb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70560bb8",
  null
  
)

export default component.exports